import { render, staticRenderFns } from "./CategoryCreateOrEdit.vue?vue&type=template&id=5962ae50&"
import script from "./CategoryCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports